import React, {Component} from 'react';
import moment from 'moment';
import EditShiftModal from './EditShiftModal';
import CreateShiftModal from './CreateShiftModal';
import { attempConfirmRecord } from 'actions/UserActions';

const WithoutRecordPast = ({activeEditModal}) => (
  <div>
    <a className="btn" onClick={activeEditModal}>
      沒有任何記錄
    </a>
  </div>
)

const WithoutRecord = ({activeCreateModal}) => (
  <div>
    <a className="btn" onClick={activeCreateModal}>
      <span className="glyphicon glyphicon-plus-sign">
      </span>
        編更
    </a>
  </div>
)

const AbsenceBtn = ({activeEditModal}) => (
  <span
      className="btn btn-danger btn-xs record-status"
      onClick={activeEditModal}
    >
      缺{" "}席
    </span>
)

const InvalidBtn = ({activeEditModal}) => (
  <span
      className="btn btn-warning btn-xs record-status"
      onClick={activeEditModal}
    >
      無{" "}效
    </span>
)

const ConfirmedBtn = ({activeEditModal, sid, workUnit}) => (
  <span
      className="btn btn-primary btn-xs record-status"
      onClick={activeEditModal}
    >
      {( sid<2 ? "已確認" : workUnit)}
    </span>
)

const SingledBtn = ({supervisorConfirm, sid, workUnit, hasAssign, activeEditModal}) => (
  <span
      className="btn btn-success btn-xs record-status"
      onClick={(hasAssign? supervisorConfirm: activeEditModal)}
    >
      {( sid<2 ? "已簽到" : workUnit)}
    </span>
)

const UnsignBtn = ({supervisorConfirm, hasAssign, activeEditModal}) => (
  <span
      className="btn btn-default btn-xs record-status"
      onClick={(hasAssign? supervisorConfirm: activeEditModal)}
    >
      未簽到
    </span>
)


const WithRecord = ({record, hasAssign, activeEditModal, supervisorConfirm, isPast, sid, sessionConfig, positionName}) => {
  let checkAt = record.getIn(['checkRecords', 0, 'checkAt']);
  let confirmAt = record.get('confirmAt');
  let cid = record.get('cid') || 0;
  let status = record.getIn(['checkRecords', 0, 'status'])
  if (record.get('checkRecords').size > 1) 
    status = status || record.getIn(['checkRecords', 1, 'status'])
  let btn = <UnsignBtn supervisorConfirm={supervisorConfirm(record)} hasAssign={hasAssign && cid > 0} activeEditModal={activeEditModal} />
  let siteName = record.get("site_name");
  let workUnit = 0;

  if (sid > 1) {
    let checkOut = record.get('checkRecords').size > 1 && record.getIn(['checkRecords', 1, 'checkAt']);
    let checkOutStatus = record.get('checkRecords').size > 1 && record.getIn(['checkRecords', 1, 'status']);
    let otOffset = record.get('otOffset') || 0;
    if (checkAt !== null && checkOut && status === 0 && checkOutStatus === 0) {
      checkAt = moment(checkAt, 'YYYY-MM-DD HH:mm:ss');
      checkOut = moment(checkOut, 'YYYY-MM-DD HH:mm:ss');
      let OTConfig = sessionConfig.get(2);
      let minPerShift = OTConfig.get('minPerShift');
      let minWorkTime = OTConfig.get('minWorkTime');
      let OTWorkUnitPerShift = OTConfig.get('workUnitPerShift');
      let OTduration = moment.duration(checkOut.diff(checkAt));
      let minsOfOT = OTduration.hours() * 60 + OTduration.minutes();
      let shiftNumber = ~~(minsOfOT / minPerShift) + (minsOfOT % minPerShift > minWorkTime? 1 : 0);
      workUnit += (shiftNumber * OTWorkUnitPerShift);
    }
    workUnit += otOffset;
    workUnit = (workUnit > 0 ? workUnit : 0)
  }

  if (confirmAt !== null) {
    btn = <ConfirmedBtn activeEditModal={activeEditModal} sid={sid} workUnit={workUnit}/>
  } else if (status !== 0) {
    btn = <InvalidBtn activeEditModal={activeEditModal} />
  } else if (checkAt !== null) {
    btn = <SingledBtn hasAssign={hasAssign && cid > 0} activeEditModal={activeEditModal} supervisorConfirm={supervisorConfirm(record)} sid={sid} workUnit={workUnit} />
  } else if (isPast) {
    btn = <AbsenceBtn activeEditModal={activeEditModal} />
  }

  return (
    <div>
      {btn}
        {" "}
      <a className="btn" onClick={activeEditModal}>
        {(siteName === null ? "沒有編更記錄" : siteName)}
        { cid > 0 && 
          <span>
            <br/>
            <span className="glyphicon glyphicon-user"></span>
            {positionName}
          </span>
        }
      </a>
    </div>
  )
}

export default class WorkerShiftRecordCol extends Component {
  state = {
    createShift: false,
    editRecord: false
  }

  supervisorConfirm = (record) => {
    return () => {
      this.props.dispatch(attempConfirmRecord(
          record.get('uid'),
          record.get('date'),
          record.get('sid')
        )
      );
    }
  }

  activeCreateModal = () => {
    this.setState({
      createShift: true
    })
  }

  dismissCreateModal = () => {
    this.setState({
      createShift: false
    })
  }

  activeEditModal = () => {
    this.setState({
      editRecord: true
    })
  }

  switchToCreateModal = () => {
    this.setState({
      createShift: true,
      editRecord: false,
    })
  }

  dismissEditModal = () => {
    this.setState({
      editRecord: false
    })
  }

  render() {
    let {editRecord, createShift} = this.state;
    let {date, record, sid, sessionConfig, positionList} = this.props;
    let shiftDisableAt = sessionConfig.getIn([sid, 'disableAt']);
    let shiftAbleAt = sessionConfig.getIn([sid, 'ableAt']);
    shiftDisableAt = moment(date.format("YYYY-MM-DD:") + shiftDisableAt, "YYYY-MM-DD:HH:mm")
                      .add((shiftAbleAt > shiftDisableAt? 1 : 0), 'days');
    let isPast = moment().diff(shiftDisableAt, 'minutes') > 0;
    let hasRecord = (record !== undefined);
    let hasChecked = hasRecord && record.get('checkRecords').get(0).get('checkAt') !== null;
    let hasAssign = (hasRecord? (record.get("cid") !== 0 && record.get("cid") !== null): false);
    hasRecord = (hasChecked || hasAssign);
    let pid = hasRecord && record.get("pid");
    let position = pid && positionList.find(p => p.get("id") == pid)
    let positionName = position ? position.get("name") : "";

    return (
      <td>
        {(isPast && !hasRecord) &&
          <WithoutRecordPast activeEditModal={this.activeEditModal} />
        }

        {(!isPast && !hasRecord) &&
          <WithoutRecord activeCreateModal={this.activeCreateModal} />
        }

        {hasRecord &&
          <WithRecord
            record={record}
            hasAssign={hasAssign}
            activeEditModal={this.activeEditModal}
            supervisorConfirm={this.supervisorConfirm}
            sessionConfig={sessionConfig}
            sid={this.props.sid}
            isPast={isPast}
            positionName={positionName}
          />
        }

        {createShift &&
          <CreateShiftModal
            {...this.props}
            dismiss={this.dismissCreateModal}
            />}

        {editRecord &&
          <EditShiftModal
            {...this.props}
            switchToCreateModal={this.switchToCreateModal}
            dismiss={this.dismissEditModal}/>}
      </td>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Schedule/WorkerShiftRecordCol.js